export default "__VITE_ASSET__59e76c57__"